import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
  en: {
    menu: {
      dashboard: 'Dashboard',
      centre: 'Centres',
      learner: 'Learners',
      qualification: 'Qualifications',
      unit: 'Units',
      certification: 'Certifications',
      reporting: 'Reporting',
      admin: 'Admin'
    },
    header: {
      account: 'Account',
      profile: 'Profile',
      logout: 'Logout'
    },
    centre: {
      centre: 'Centres',
      code: 'Code',
      name: 'Name',
      city: 'City',
      firstApprovedDate: 'First Approved Date',
      renewalDate: 'Renewal Date',
      ukprn: 'UKPRN / Trainer Number',
      status: 'Status',
      addressLine1: 'Address Line 1',
      addressLine2: 'Address Line 2',
      addressLine3: 'Address Line 3',
      postcode: 'Post Code',
      country: 'Country',
      mainContactEmail: 'Main Contact Email',
      mainContactTelephone: 'Main Contact Telephone',
      mainContactMobile: 'Main Contact Mobile',
      adminContactEmail: 'Admin Contact Email',
      adminContactTelephone: 'Admin Contact Telephone',
      adminContactMobile: 'Admin Contact Mobile',
      accountContactEmail: 'Account Contact Email',
      acoountContactTelephone: 'Account Contact Telephone',
      accountContactMobile: 'Account Contact Mobile',
    },
    learner: {
      learner: 'Learners',
      code: 'Code',
      name: 'Name',
      centre: 'Centre',
      firstApprovedDate: 'First Approved Date',
      renewalDate: 'Renewal Date',
      ukprn: 'UKPRN / Trainer Number',
      status: 'Status',
    },
    qualification: {
      qualification: 'Qualifications',
      uan: 'UAN',
      code: 'Code',
      level: 'Level',
      credits: 'Credits',
      name: 'Name',
    },
    unit: {
      unit: 'Units',
      uan: 'UAN',
      level: 'Level',
      credits: 'Credits',
      name: 'Name',
      coursesAssociated: 'Courses associated with',
    },
    user: {
      user: 'User',
      username: 'Name',
      email: 'Email',
      role: 'Role',
    },
    country: {
      country: 'Country',
      name: 'Name',
      code: 'Code'
    },
    nationality: {
      nationality: 'Nationality',
      name: 'Name'
    },
    ethnicity: {
      ethnicity: 'Ethnicity',
      name: 'Name'
    },
    type: {
      type: 'Qualification / Unit Type',
      name: 'Type'
    },
    level: {
      level: 'Qualification / Unit Level',
      name: 'Level'
    },
    status: {
      status: 'Qualification / Unit Status',
      name: 'Status'
    },
    language: {
      language: 'Language',
      name: 'Language'
    },
    centreStatus: {
      centreStatus: 'Centre Status',
      name: 'Status'
    },
    gradingCriterion: {
      gradingCriterion: 'Grading Criterions',
      name: 'Criterion'
    },
    table: {
      search: 'Search',
      export: 'Export data',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      actions: 'Actions'
    }
  },
  zhHans: {
    menu: {
      dashboard: '首页',
      centre: '中心',
      learner: '学生',
      qualification: '资格',
      unit: '单元',
      certification: '证书',
      reporting: '报告',
      admin: '管理员'
    },
    header: {
      account: '户口',
      profile: '个人资料',
      logout: '登出'
    },
    centre: {
      centre: '中心',
      code: '代码',
      name: '名称',
      city: '城市',
      firstApprovedDate: '首次批准日期',
      renewalDate: '更新日期',
      ukprn: '培训师编号',
      status: '状态',
      addressLine1: '地址栏 1',
      addressLine2: '地址栏 2',
      addressLine3: '地址栏 3',
      postcode: '邮编',
      country: '国家',
      mainContactEmail: '主要联系人电子邮件',
      mainContactTelephone: '主要联系电话',
      mainContactMobile: '主要联系人手机',
      adminContactEmail: '管理员联系电子邮件',
      adminContactTelephone: '管理员联系电话',
      adminContactMobile: '管理员联系手机',
      accountContactEmail: '帐户联系电子邮件',
      acoountContactTelephone: '帐号联系电话',
      accountContactMobile: '帐户联系手机',
    },
    learner: {
      learner: '学生',
      id: '身分证',
      name: '名称',
      centre: '中心',
      firstApprovedDate: '首次批准日期',
      renewalDate: '更新日期',
      ukprn: '培训师编号',
      status: '状态',
    },
    qualification: {
      qualification: '资格',
      uan: '特殊',
      code: '代码',
      level: '等级',
      credits: '学分',
      name: '名称',
    },
    unit: {
      unit: '单元',
      uan: '特殊',
      level: '等级',
      credits: '学分',
      name: '名称',
      coursesAssociated: '与之相关的课程',
    },
    user: {
      user: '用户',
      username: '用户名',
      email: '电子邮件',
      role: '角色',
    },
    country: {
      country: '国家',
      name: '名称',
      code: ' 代码'
    },
    nationality: {
      nationality: '国籍',
      name: '国籍'
    },
    ethnicity: {
      ethnicity: '种族',
      name: '种族'
    },
    type: {
      type: '类型',
      name: '类型'
    },
    level: {
      level: '水平',
      name: '水平'
    },
    status: {
      status: '状态',
      name: '状态'
    },
    language: {
      language: '语言',
      name: '语言'
    },
    centreStatus: {
      centreStatus: '中心状态',
      name: '中心状态'
    },
    gradingCriterion: {
      gradingCriterion: '评分标准',
      name: '评分标准'
    },
    table: {
      search: '搜索',
      export: '汇出资料',
      add: '添加',
      edit: '编辑',
      delete: '删除',
      actions: '动作'
    }
  },
  ko: {
    menu: {
      dashboard: '계기반',
      centre: '센터',
      learner: '학습자',
      qualification: '자격',
      unit: '단위',
      certification: '인증',
      reporting: '보고',
      admin: '관리자'
    },
    header: {
      account: '계정',
      profile: '프로필',
      logout: '로그 아웃'
    },
    centre: {
      centre: '센터',
      code: '암호',
      name: '이름',
      city: '시티',
      firstApprovedDate: '첫 승인 날짜',
      renewalDate: '갱신일',
      ukprn: '트레이너 번호',
      status: '상태',
      postcode: '상태',
      country: '상태',
      mainContactEmail: '상태',
      mainContactTelephone: '상태',
      mainContactMobile: '상태',
      adminContactEmail: '상태',
      adminContactTelephone: '상태',
      adminContactMobile: '상태',
      accountContactEmail: '상태',
      acoountContactTelephone: '상태',
      accountContactMobile: '상태',
    },
    learner: {
      learner: '학습자',
      id: '신분증',
      name: '이름',
      centre: '센터',
      firstApprovedDate: '첫 승인 날짜',
      renewalDate: '갱신일',
      ukprn: '트레이너 번호',
      status: '상태',
    },
    qualification: {
      qualification: '자격',
      uan: '독특한',
      code: '암호',
      level: '수평',
      credits: '크레딧',
      name: '이름',
    },
    unit: {
      unit: '단위',
      uan: '독특한',
      level: '수평',
      credits: '크레딧',
      name: '이름',
      coursesAssociated: '관련 코스',
    },
    user: {
      user: '사용자',
      username: '사용자 이름',
      email: '이메일',
      role: '역할',
    },
    country: {
      country: '국가',
      name: '이름',
      code: '암호'
    },
    nationality: {
      nationality: '국적',
      name: '국적'
    },
    ethnicity: {
      ethnicity: '민족',
      name: '민족'
    },
    type: {
      type: '유형',
      name: '유형'
    },
    level: {
      level: '水平',
      name: '水平'
    },
    status: {
      status: '상태',
      name: '상태'
    },
    language: {
      language: '언어',
      name: '언어'
    },
    centreStatus: {
      centreStatus: '센터 상태',
      name: '센터 상태'
    },
    gradingCriterion: {
      gradingCriterion: '채점 기준',
      name: '채점 기준'
    },
    table: {
      search: '검색',
      export: '데이터 내보내기',
      add: '더하다',
      edit: '편집하다',
      delete: '지우다',
      actions: '행위'
    }
  }
}

export const i18n = new VueI18n({
  locale: 'en', // set locale
  fallbackLocale: 'en',
  messages
});